import React from 'react'
import IconButton from '@mui/material/IconButton'
import Grid from '@mui/material/Grid'
import MessageIcon from '@mui/icons-material/Message'
import BugReportIcon from '@mui/icons-material/BugReport'
import Details from '../../../assets/images/info.png'
import Map from '../../../assets/images/map.png'
import { Dialog, DialogContent } from '@material-ui/core'
import DialogActions from '@mui/material/DialogActions'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import ClearIcon from '@mui/icons-material/Clear'
import { NavigateBefore, NavigateNext } from '@mui/icons-material'
import CircularProgress from '@mui/material/CircularProgress'
import LoadingTime from '../../../assets/images/sand_clock.png'
import usePlantTechicalViewStyles from '../styles.js'
import PlantDetailsContent from '../components/PlantDetailsDialog/PlantDetailsContent'
import dayjs from 'dayjs'
import InverterViewGraph from '../components/InverterViewGraph/InverterViewGraph'
import TechnicalViewGraph from '../components/TechnicalViewGraph/TechnicalViewGraph'
import EnergyAnalysisGraph from '../components/EnergyAnalysisGraph/EnergyAnalysisGraph'
import { Button, Tab, Tabs } from '@mui/material'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import RawDataDownload from '../components/RawData/RawDataDownload.jsx'
import LiveDataView from '../components/LiveDataView/LiveDataView'

const PlantTechnicalViewDesktop = ({ logic, permissions }) => {
    const {
        plantContent,
        liveData,
        hourGlassValue,
        notifications,
        notificationCount,
        loading,
        page,
        setPage,
        totalPages,
        showNotifications,
        setShowNotifications,
        selectedNotification,
        setSelectedNotification,
        activeTab,
        setActiveTab,
        issueCount,
        liveTabActive,
        setLiveTabActive,
        open,
        setOpen,
        dleted,
        setdelete,
        markNotificationAsRead,
        markNotificationAsDone,
        markCurrentNotificationAsDone,
        handleDeleteplant,
        handleIssueManagement,
        handleBusinessView,
        handlePlantMapView,
        handleOpenEdit,
        state,
        token
    } = logic

    const { is, can } = permissions
    const classes = usePlantTechicalViewStyles()

    const NotificationCard = () => (
        <div className="plant_card column_align notification-box" onClick={() => setShowNotifications(true)}>
            <div className="align_btw">
                <div className="txt1">Notifications</div>
                <div className="notification-badge">
                    <MessageIcon className="msg_i" />
                    {notificationCount > 0 && <span className="badge">{notificationCount}</span>}
                </div>
            </div>
            <div>
                {notifications.length > 0 ? (
                    <div className="line_trim">{notifications[0].message}</div>
                ) : (
                    <div className="no-notifications">No notifications</div>
                )}
            </div>
            {notifications.length > 0 && <div className="more_link"><span>More</span></div>}
        </div>
    )

    const NotificationDialog = () => (
        <Dialog
            open={showNotifications}
            onClose={() => { setShowNotifications(false); setSelectedNotification(null); }}
            maxWidth="md"
            fullWidth
            className="notification-dialog"
        >
            <div className="notification-dialog-header">
                <span>Notifications</span>
                <Tabs value={activeTab} onChange={(e, newValue) => { setActiveTab(newValue); setPage(1); }} className="notification-tabs">
                    <Tab value="unread" label="Unread" />
                    <Tab value="read" label="Read" />
                </Tabs>
                <IconButton onClick={() => { setShowNotifications(false); setSelectedNotification(null); }} className="close-button"><ClearIcon /></IconButton>
            </div>
            <DialogContent>
                {loading ? (
                    <div className="loading-spinner"><CircularProgress size={20} /></div>
                ) : selectedNotification ? (
                    <div className="notification-detail">
                        <div className="notification-detail-header">
                            <IconButton onClick={() => setSelectedNotification(null)} className="back-button"><NavigateBefore /></IconButton>
                            <Button
                                variant="contained" color="primary" className="done-button"
                                startIcon={<CheckCircleOutlineIcon />} onClick={markCurrentNotificationAsDone}
                                disabled={selectedNotification?.isDone}
                            >
                                {selectedNotification?.isDone ? 'Completed' : 'Mark as Done'}
                            </Button>
                        </div>
                        <div className="notification-detail-content">
                            <h3>{selectedNotification.plantName}</h3>
                            <p className="timestamp">{dayjs(selectedNotification.created_at).format('DD MMM YYYY | HH:mm')}</p>
                            <p className="message">{selectedNotification.message}</p>
                            {selectedNotification.isDone && (
                                <div className="done-status">
                                    <CheckCircleOutlineIcon color="success" /> Marked as done on {dayjs(selectedNotification.doneAt).format('DD MMM YYYY | HH:mm')}
                                </div>
                            )}
                        </div>
                    </div>
                ) : notifications.length > 0 ? (
                    <>
                        <div className="notification-list">
                            {notifications.map((notification) => (
                                <div
                                    key={notification.id}
                                    className={`notification-item ${notification.status === 'read' ? 'read' : 'unread'} ${notification.isDone ? 'done' : ''}`}
                                    onClick={() => notification.status === 'unread' ? markNotificationAsRead(notification) : setSelectedNotification(notification)}
                                >
                                    <div className="notification-content">
                                        <div className="notification-header">
                                            <span className="plant-name">{notification.plantName}{notification.severity === 'high' && <span className="severity-indicator">●</span>}</span>
                                            <span className="timestamp">{dayjs(notification.created_at).format('DD MMM YYYY | HH:mm')}</span>
                                        </div>
                                        <p className="message">{notification.message}</p>
                                        <div className="notification-actions">
                                            {notification.isDone ? (
                                                <div className="done-indicator"><CheckCircleOutlineIcon color="success" fontSize="small" /> Completed</div>
                                            ) : (
                                                <Button size="small" variant="outlined" color="primary" className="done-button" startIcon={<CheckCircleOutlineIcon />} onClick={(e) => markNotificationAsDone(notification, e)}>Mark as Done</Button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {totalPages > 1 && (
                            <div className="pagination">
                                <IconButton disabled={page === 1} onClick={() => setPage((p) => p - 1)}><NavigateBefore /></IconButton>
                                <span>{`${page} / ${totalPages}`}</span>
                                <IconButton disabled={page === totalPages} onClick={() => setPage((p) => p + 1)}><NavigateNext /></IconButton>
                            </div>
                        )}
                    </>
                ) : (
                    <div className="no-notifications-message">No {activeTab} notifications</div>
                )}
            </DialogContent>
        </Dialog>
    )

    return (
        <div className={classes.root} id="plantTechnicalView">
            <div className="align_btw mb_10">
                <div>
                    <div className="plant_list_h">
                        <div className="h_txt1">{plantContent?.plantName}</div>
                        <div className="h_txt2">{plantContent?.projectCode}</div>
                    </div>
                </div>
                <div>
                    <div className="align_end wrap">
                        <div className="load_d_p">
                            <CircularProgress variant="determinate" sx={{ scale: '-1 1' }} value={hourGlassValue} color="success" className="progress-bar" />
                            <div className="loader_pos"><img src={LoadingTime} alt="" className="load_width" /></div>
                        </div>
                        <div className="plant_list_h_button mr_8" onClick={() => setOpen(true)}><img src={Details} alt="details" className="mr_6" /> Plant Details</div>
                        <div className="plant_list_h_button mr_8" onClick={handlePlantMapView}><img src={Map} alt="details" className="mr_6" /> Location</div>
                        {(is('Super Admin') || is('Admin') || is('Asset Management') || can('issue.all') || can('issue.read')) && (
                            <div className="plant_list_h_button mr_8" onClick={handleIssueManagement} style={{ position: 'relative' }}>
                                <BugReportIcon className="mr_6" style={{ fontSize: '18px' }} /> Issues
                                {issueCount > 0 && <span className="issue-badge">{issueCount}</span>}
                            </div>
                        )}
                        <>
                            {(is('Super Admin') || is('Admin') || is('Asset Management') || is('')) && <RawDataDownload plantData={plantContent} state={state} />}
                            <div className="business_tech_toggle" onClick={handleBusinessView}>
                                <label className="switch"><input type="checkbox" /><span className="slider"></span></label>
                            </div>
                        </>
                    </div>
                </div>
            </div>
            <hr className="brdr_btm" />
            <Dialog className="plant_details_dialog" open={open} onClose={() => setOpen(false)} maxWidth="xl" fullWidth>
                <DialogActions><ClearIcon onClick={() => setOpen(false)} className="pointer" /></DialogActions>
                <div className="header">
                    <div className="align_btw brdr">
                        <div><div className="h_1">Plant Details</div></div>
                        <div>
                            <div className="align_end">
                                <span className="h_2">{plantContent?.plantName}</span>
                                {(is('Super Admin') || is('Admin') || can('plant.update') || can('plant.delete')) && (
                                    <>
                                        {(is('Super Admin') || is('Admin') || can('plant.update')) && (
                                            <IconButton onClick={handleOpenEdit}><EditIcon className="i_clr" /></IconButton>
                                        )}
                                        {(is('Super Admin') || is('Admin') || can('plant.delete')) && (
                                            <IconButton onClick={() => setdelete(true)}><DeleteIcon className="i_clr" /></IconButton>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <DialogContent><PlantDetailsContent plantData={plantContent} dleted={dleted} handleCloseDelete={() => setdelete(false)} handleDeleteplant={handleDeleteplant} /></DialogContent>
            </Dialog>
            {!is('Client') ? (
                <div>
                    <div className="plant_main_card_row mb_10">
                        <div className="plant_card column_align"><div className="txt1">Daily Energy (MFM)</div><div className="txt2">{liveData.dailyEnergyMFM}</div><div className="txt3">kWh</div></div>
                        <div className="plant_card column_align"><div className="txt1">Inverter E. Today (Inverter)</div><div className="txt2">{liveData.inverterEToday}</div><div className="txt3">kWh</div></div>
                        <div className="plant_card column_align"><div className="txt1">IR</div><div className="txt2">{liveData.gtiValue}</div><div className="txt3">kWh/m<sup>2</sup></div></div>
                        <div className="plant_card column_align"><div className="txt1">Specific Yield</div><div className="txt2">{liveData.specificYield}</div><div className="txt3">kWh/kWp</div></div>
                        <div className="plant_card column_align"><div className="txt1">CO2 Avoided</div><div className="txt2">{liveData.co2Avoided}</div><div className="txt3">Tonnes</div></div>
                        <NotificationCard />
                    </div>
                    <div className="main-tabs-container">
                        <Tabs value={liveTabActive} onChange={(e, newValue) => setLiveTabActive(newValue)} className="main-tabs">
                            <Tab value="graphs" label="Graphs" />
                            <Tab value="live" label="Live" />
                        </Tabs>
                        {liveTabActive === 'graphs' && (
                            <div className="graphs-tab-content">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6}><TechnicalViewGraph state={state?.data} plantContent={plantContent} token={token} /></Grid>
                                    <Grid item xs={12} md={6}><InverterViewGraph state={state?.data} plantContent={plantContent} token={token} /></Grid>
                                    <Grid item xs={12} md={6}><EnergyAnalysisGraph state={state?.data} plantContent={plantContent} token={token} /></Grid>
                                </Grid>
                            </div>
                        )}
                        {liveTabActive === 'live' && (
                            <div className="live-tab-content"><LiveDataView plantData={plantContent} token={token} /></div>
                        )}
                    </div>
                    <NotificationDialog />
                </div>
            ) : (
                <div><Grid item xs={12} md={12}><InverterViewGraph state={state?.data} plantContent={plantContent} token={token} /></Grid></div>
            )}
        </div>
    )
}

export default PlantTechnicalViewDesktop
